// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"73d239f8","732":"93e29736"}[chunkId] + ".chunk.js";
};